import React, { createContext, useCallback, useEffect, useState } from 'react';
import ErrorPage from '../pages/ErrorPage';
import LoadingPage from '../pages/LoadingPage';
import ImageViewer from '../components/ImageViewer';
import Wrapper from '../components/Wrapper';
import { useSearchParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import TagManager from 'react-gtm-module';
import i18n from '../config/i18n';
import { useFlow } from './FlowContext';

const GTM_IDS = [
  /*'GTM-PLBRD26'*/
];
const eventPages = {
  Landing_page_visit: {
    pageTitle: 'Registration Benefit 3',
    pagePath: '/3/ssr/benefit',
    pageCategory: 'Registration Benefit 3',
  },

  nav_to_country_residence: {
    pageTitle: 'Country Selection 3',
    pagePath: '/3/ssr/country',
    pageCategory: 'Country Selection 3',
  },
  nav_birth_date: {
    pageTitle: 'Date of Birth 3',
    pagePath: '/3/ssr/birthdate',
    pageCategory: 'Date of Birth 3',
  },

  nav_to_code: {
    pageTitle: 'Device Codentify 3',
    pagePath: '/3/ssr/codentify',
    pageCategory: 'Device Codentify 3',
  },
  nav_to_your_devices: {
    pageTitle: 'Device Summary 3',
    pagePath: '/3/ssr/device_summary',
    pageCategory: 'Device Summary 3',
  },

  nav_to_final_page: {
    pageTitle: 'Registration Confirmation 3',
    pagePath: '/3/ssr/confirmation',
    pageCategory: 'Registration Confirmation 3',
  },
  nav_to_number: {
    pageTitle: 'Mobile Phone 3',
    pagePath: '/3/ssr/mobile_phone',
    pageCategory: 'Mobile Phone 3',
  },
  nav_to_phone_code: {
    pageTitle: 'Phone Verification 3',
    pagePath: '/3/ssr/verification',
    pageCategory: 'Phone Verification 3',
  },
  nav_to_first_name: {
    pageTitle: 'Firstname 3',
    pagePath: '/3/ssr/firstname',
    pageCategory: 'Firstname 3',
  },
  nav_to_last_name: {
    pageTitle: 'Lastname 3',
    pagePath: '/3/ssr/lastname',
    pageCategory: 'Lastname 3',
  },
  nav_to_email: {
    pageTitle: 'Email 3',
    pagePath: '/3/ssr/email',
    pageCategory: 'Email 3',
  },
  nav_to_zip_code: {
    pageTitle: 'Zip Code 3',
    pagePath: '/3/ssr/zipcode',
    pageCategory: 'Zip Code 3',
  },
};

const initializeGTM = () => {
  GTM_IDS.forEach((gtmId) => {
    TagManager.initialize({ gtmId });
  });
};
const sendEventToGTM = (eventName) => {
  GTM_IDS.forEach((gtmId) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      gtmId,
    });
  });
};
// Create the context
const DataContext4 = createContext();
const steps = 10;

// Create a provider component
const DataContext4Provider = ({ children }) => {
  const { setFlowNumber } = useFlow();
  useEffect(() => {
    setFlowNumber(4);
  }, []);
  const [gtmReady, setGTMReady] = useState(false);
  const [eventQueue, setEventQueue] = useState([]);
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(0);
   let initialDate = new Date('1980-06-15');
   const parsed = JSON.parse(localStorage.getItem('ageConfirmation') || '{}');
      const { day, month, year } = parsed;

      if (day && month && year) {
        initialDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
  const [data, setData] = useState({
    country: 'luxembourg',
    uuid: uuidv4(),
    phonenumber: '+352',
    smsConfirmationCode: '',
    zip: '',
    firstname: '',
    lastname: '',
    dob: initialDate,
    email: '',
    agreements: [false, false, false],
    isCodeDisabled: false,
    code: '',
    src: '',
    isCompliant: '',
    isReturning: true,
    shopId: searchParams.get('id')?.length
      ? searchParams.get('id')
      : localStorage.getItem('shopId'),
    smsCodeSentCount: 0,
  });

  useEffect(() => {
    initializeGTM();
    setGTMReady(true);
  }, []);

  useEffect(() => {
    if (gtmReady && eventQueue.length > 0) {
      eventQueue.forEach((event) => {
        sendEventToGTM(event);
      });
      setEventQueue([]);
    }
  }, [gtmReady, eventQueue]);

  const trackEvent = useCallback(
    (eventName) => {
      if (gtmReady) {
        sendEventToGTM(eventName);
      } else {
        setEventQueue((prevQueue) => [...prevQueue, eventName]);
      }
    },
    [gtmReady]
  );

  const value = {
    currentStep,
    setCurrentStep,
    data,
    setData,
    trackEvent,
    steps,
  };

  return (
    <DataContext4.Provider value={value}>
      <Wrapper>
        {searchParams.get('error') ? (
          <ErrorPage />
        ) : searchParams.get('loading') ? (
          <LoadingPage />
        ) : searchParams.get('image') ? (
          <ImageViewer />
        ) : (
          children
        )}
      </Wrapper>
    </DataContext4.Provider>
  );
};

export { DataContext4, DataContext4Provider };
